<base-support-modal [title]="title" [btnOkClass]="allowFreemium ? 'btn-danger' : 'btn-success'" [btnOkLabel]="allowFreemium ? 'Удалить' : 'Назначить'" (onOk)="ok()" >
	<p>
		{{allowFreemium ? 'Убрать' : 'Назначить'}} <mark>freemium</mark>-режим для пользователя?
	</p>

	<p>
		<mark>Изменение <strong>НЕ</strong> затронет <strong>СУЩЕСТВУЮЩИЕ</strong> пользовательские сайты.</mark>
	</p>
</base-support-modal>
